module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldIt.20ebe9b.woff2";